import type { Training } from "@bmi/elasticsearch-types";
import type {
  PayloadTrainingListerPage,
  PayloadTrainingRegistrationPage
} from "../../types/payload";
import type { BreadcrumbData } from "../../components/Breadcrumbs";
import type { HomePageData, SiteData as SiteData } from "../../components/Site";
import type { ESResponse } from "../../types/elasticsearch";
import type { MicroCopy as MicroCopyData } from "../../components/MicroCopy";
import type { CalculatorConfig } from "../../components/pitched-roof-calculator/types";
import type { HouseType } from "../../components/visualiser/Types";
import type { GeneralErrorData } from "../general-error";
import type { CountryNavigation, SampleOrder } from "../../components/Header";
import type { Visualiser } from "../../components/Visualiser";

export type TrainingRegistrationPageData = Pick<
  PayloadTrainingRegistrationPage,
  | "breadcrumbTitle"
  | "path"
  | "title"
  | "salutationTitle"
  | "salutationMale"
  | "salutationFemale"
  | "firstName"
  | "lastName"
  | "email"
  | "companyName"
  | "position"
  | "customerNumber"
  | "city"
  | "street"
  | "postalCode"
  | "phoneNumber"
  | "competentChamber"
  | "recipient"
  | "emailSubject"
  | "competentChamberLabel"
  | "bmiSystemPartnerClubTitle"
  | "isMemberOfBmiLabel"
  | "isNotMemberOfBmiLabel"
  | "discoverySourceTitle"
  | "discoverySourceBrochure"
  | "discoverySourceFieldService"
  | "discoverySourceWebsite"
  | "discoverySourceFacebook"
  | "discoverySourceInstagram"
  | "discoverySourceXing"
  | "discoverySourceLinkedin"
  | "discoverySourceOther"
  | "discoverySourceSpecifyOther"
  | "comment"
  | "extraParticipantTitle"
  | "extraParticipantSubtitle"
  | "addParticipantsButton"
  | "newParticipantTitle"
  | "removeParticipantButton"
  | "newParticipantFirstName"
  | "newParticipantLastName"
  | "consentText"
  | "termsOfUse"
  | "registerButton"
> & {
  breadcrumbs: readonly BreadcrumbData[];
};

export type TrainingRegistrationPageProps = {
  data: {
    payloadTrainingRegistrationPage: TrainingRegistrationPageData;
    payloadTrainingListerPage:
      | (Pick<PayloadTrainingListerPage, "path"> & {
          breadcrumbs: readonly BreadcrumbData[];
        })
      | null;
    payloadSite: SiteData;
    allPayloadMicroCopy: {
      nodes: MicroCopyData[];
    };
    payloadPitchedRoofCalculatorConfig: CalculatorConfig | null;
    allPayloadHouseModel: {
      nodes: HouseType[];
    };
    payloadHomePage: HomePageData;
    payloadGeneralError: GeneralErrorData;
    payloadCountryNavigation: CountryNavigation;
    payloadSampleOrder: SampleOrder | null;
    payloadVisualiser: Visualiser | null;
  };
};

export type ESTrainingDetails = ESResponse<Training>;

export enum FormStatus {
  Initialized = "initialized",
  Edited = "edited"
}
